import { createModelStore } from '@/shared/stores/create-model-store'
import { model5InitialModel } from './initial-state'
import { model5DimensionHandlers } from './dimensions'

export const useModel5Store = createModelStore({
  initialModel: model5InitialModel,
  dimensionHandlers: model5DimensionHandlers,
})
